module.exports = __webpack_public_path__ + "img/CZ49241257.64efdccb.png";